<div class="main-content">
  <div *ngIf="isLoading" class="overlay">
    <div class="spinner"></div>
  </div>
    <div class="container-fluid">
      <div class="row mb-6 justify-content-center">
        <div class="col-md-6 text-center">
          <a class="btn btn-dark btn-sm btn-initial" (click)="back()">
            Back
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header card-header-icon">
              <div class="card-icon">
                <i class="material-icons">receipt</i>
              </div>
              <h4 class="card-title">{{ id ? 'Update' : 'New' }} item</h4>
            </div>
  
            <div class="card-body">
              <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="name"
                        >Item name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="name"
                        formControlName="name"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('name')"
                      >
                        The item name is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="rate">Rate</label>
                      <input
                        type="number"
                        class="form-control"
                        id="rate"
                        formControlName="rate"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('item')"
                      >
                        The rate is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="description"
                        >Description</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="description"
                        formControlName="description"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('description')"
                      >
                        The description is required
                      </div>
                    </div>
                  </div>
                </div>
  
                <button
                  type="submit"
                  class="btn btn-dark btn-sm pull-right btn-initial"
                  [disabled]="form.invalid"
                >
                {{ id ? 'Update' : 'Create' }}
                </button>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  